/**
 * Video de tips: arranca solo y en silencio (de eso se encarga eclipse-video.js,
 * que además lo dispara recién cuando entra en pantalla), y muestra un botón que
 * invita a activar el audio. Al tocarlo empieza de nuevo desde el principio: es
 * una explicación hablada y entrar a la mitad no se entiende.
 */
(() => {
  const SELECTOR = '[data-ec-tips]';

  const setup = (box) => {
    if (box.dataset.ecTipsReady === 'true') return;
    box.dataset.ecTipsReady = 'true';

    const video = box.querySelector('video');
    const button = box.querySelector('[data-ec-tips-sound]');
    if (!video || !button) return;

    button.addEventListener('click', () => {
      box.dataset.ecSound = 'on';
      button.hidden = true;

      video.loop = false;
      video.defaultMuted = false;
      video.muted = false;
      video.currentTime = 0;

      // Con los controles se puede pausar, retroceder y volver a verlo.
      video.controls = true;

      const played = video.play();
      if (played) played.catch(() => {});
    });

    // eclipse-video.js vuelve a silenciar cada vez que reanuda (al volver a
    // entrar en pantalla, por ejemplo). Si la clienta ya pidió audio, lo
    // deshacemos en cuanto arranca.
    video.addEventListener('play', () => {
      if (box.dataset.ecSound === 'on' && video.muted) video.muted = false;
    });

    // Cuando termina con sonido vuelve al estado de partida: portada, silencio,
    // bucle y el botón de nuevo a la vista. Así se puede repetir tocándolo otra
    // vez, que es lo que se espera de una explicación que dura 28 segundos.
    //
    // Antes quedaba congelado en el último fotograma y con el bucle apagado: no
    // parecía que se pudiera volver a ver.
    video.addEventListener('ended', () => {
      if (box.dataset.ecSound !== 'on') return;
      delete box.dataset.ecSound;
      video.controls = false;
      video.muted = true;
      video.loop = true;
      button.hidden = false;
      // load() devuelve la portada; sin esto se queda el último cuadro.
      try {
        video.load();
      } catch (error) {
        video.currentTime = 0;
      }
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
